import { createPortal } from "react-dom"
import { useModalStore } from "@/entities"

export const ModalRoot = () => {
  const modals = useModalStore(s => s.modals)

  if (modals.length === 0) return null

  return createPortal(
    <>
      {modals.map(m => (
        <div key={`MODAL_${m.modalType}`}>{m.component}</div>
      ))}
    </>,
    document.getElementById("modal-root")!
  )
}
